


















import Vue from "vue";
import { Dashboard, DashLayout, DashItem } from "vue-responsive-dash";
import { Component } from "vue-property-decorator";
import { http } from "@/shared/https";
import Axios from "axios";
import FilterComponent from "./Filter/Filter.vue";
@Component({
  components: {
    FilterComponent
  }
})
export default class ApplicantDashboardComponent extends Vue {
  items: any = [];
  headers: any = [];
  headersSeparator: any = [];
  inset: boolean = true;
  data() {
    this.inset = true;
    return { items: this.items };
  }
  homePageleft(e) {
    //alert(e);
    this.$emit("homePageleft", e);
  }
}
